module.exports = __webpack_public_path__ + "static/media/chick.4d4b5971.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/primary-interface/chick.svg
// module id = 616
// module chunks = 6